import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import dynamic from 'next/dynamic';

import SpacerElement from '@deliveroo/consumer-component-library/internal/SpacerElement';

import { getCurrentQuery } from '../../selectors/requestSelectors';
import { getOrderPunchCard } from '../../selectors/orderPunchCardsSelectors';

const PunchCard = dynamic(import('../../components/PunchCard'), {
  ssr: true,
});

export function PunchCardContainer({
  title,
  body,
  current,
  spacing,
  adjacentVerticalSpacing,
  adjacentHorizontalSpacing,
  wrapperClasses,
}) {
  return (
    current !== null &&
    current !== undefined && (
      <SpacerElement
        spacing={spacing}
        adjacentVerticalSpacing={adjacentVerticalSpacing}
        adjacentHorizontalSpacing={adjacentHorizontalSpacing}
        className={wrapperClasses}
      >
        <PunchCard title={title} body={body} current={current} />
      </SpacerElement>
    )
  );
}

PunchCardContainer.defaultProps = {
  title: undefined,
  body: undefined,
  current: undefined,
  remaining: undefined,
  ...SpacerElement.defaultProps,
};

PunchCardContainer.propTypes = {
  /**
   * Title of the punch card
   */
  title: PropTypes.string,
  /**
   * Body message of the punch card
   */
  body: PropTypes.string,
  /**
   * Number of confirmed and pending stamps collected for the punch card
   */
  current: PropTypes.number,
  ...SpacerElement.propTypes,
};

export const mapStateToProps = (state) => {
  const { orderId } = getCurrentQuery(state);
  const punchCardsState = getOrderPunchCard(orderId)(state);

  if (!punchCardsState) {
    return {};
  }

  return {
    title: punchCardsState.title,
    body: punchCardsState.body,
    current: punchCardsState.currentStamps,
  };
};

export default connect(mapStateToProps)(PunchCardContainer);
